import { notificationPreferencesQuery } from "@common/api/notifications"
import { currentUserQuery } from "@common/api/users"
import { hasPermission } from "@common/lib/permissions"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import { MuteAll, NotificationRules } from "./-components/preferences"
import { NOTIFICATIONS_PERMISSION } from "./-lib/permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/account/notifications/",
)({
  staticData: {
    breadcrumb: [{ label: "Account - Notifications" }],
  },
  beforeLoad: async ({ context: { queryClient } }) => {
    const user = await queryClient.ensureQueryData(currentUserQuery())
    if (!hasPermission(user, NOTIFICATIONS_PERMISSION)) {
      throw redirect({ to: "/settings/workspace/general" })
    }
  },
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(notificationPreferencesQuery()),
  component: AccountNotificationsPage,
})

function AccountNotificationsPage(): React.ReactElement {
  const { data: preferences } = useSuspenseQuery(notificationPreferencesQuery())

  return (
    <PageContent>
      <PageTitle title="Notifications" />
      <NotificationRules preferences={preferences} />
      <MuteAll preferences={preferences} />
    </PageContent>
  )
}
